const FILTER_OPTION_PRODUCT_SUB_CLASS_SUB_CLASS = {
  value: 0,
  label: '产品小类',
}
const FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_CATEGORY = {
  value: 1,
  label: '产品目录',
}
const FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_CLASS = {
  value: 2,
  label: '产品大类',
}
const FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_PRODUCT_ID = {
  value: 3,
  label: '物模型ID',
}
const FILTER_OPTION_RELATED_INTERNAL_MODEL = {
  value: 4,
  label: '关联产品型号',
  type: 'relatedInternalModel',
}
const FILTER_OPTION_RELATED_IMAGE_TYPE_IDS = {
  value: 5,
  label: '关联固件类型',
  type: 'relatedImageTypeIds',
}
const FILTER_OPTION_APP_TAG = {
  value: 6,
  label: '应用标识',
  type: 'appTag',
}
const FILTER_OPTIONS = [
  FILTER_OPTION_PRODUCT_SUB_CLASS_SUB_CLASS,
  FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_CLASS,
  FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_PRODUCT_ID,
  FILTER_OPTION_RELATED_INTERNAL_MODEL,
  FILTER_OPTION_RELATED_IMAGE_TYPE_IDS,
]
const PRODUCT_SUB_CLASS_TYPE = {
  0: '第三方产品',
  1: '网关',
  2: '子设备',
  3: '未知',
  4: '单品',
}
const PRODUCT_SUB_CLASS_KIND = {
  1: '家居类',
  0: '社区类',
}
const PRODUCT_SUB_CLASS_TYPE_OPTIONS = [
  {
    value: 0,
    label: '第三方产品',
  },
  {
    value: 1,
    label: '网关',
  },
  {
    value: 2,
    label: '子设备',
  },
  {
    value: 3,
    label: '未知',
  },
  {
    value: 4,
    label: '单品',
  },
]
const PRODUCT_SUB_CLASS_KIND_OPTIONS = [
  {
    value: 1,
    label: '家居类',
  },
  {
    value: 0,
    label: '社区类',
  },
]
const SCREEN_RESOLUTION = {
  0: '未知',
  1: '宽1920 x 高1080',
  2: '宽480 x 高480',
  3: '宽1920 x 高515',
  4: '宽1280 x 高400',
  5: '宽1024 x 高600',
}
const SCREEN_RESOLUTION_OPTIONS = [
  {
    value: 1,
    label: '宽1920 x 高1080',
  },
  {
    value: 2,
    label: '宽480 x 高480',
  },
  {
    value: 3,
    label: '宽1920 x 高515',
  },
  {
    value: 4,
    label: '宽1280 x 高400',
  },
  {
    value: 5,
    label: '宽1024 x 高600',
  },
]
const APP_TAG = {
  1: 'AIHome',
  2: '智慧空间',
  3: 'NexSmart',
}
const APP_TAG_OPTIONS = [
  {
    value: 1,
    label: 'AIHome',
  },
  {
    value: 2,
    label: '智慧空间',
  },
  {
    value: 3,
    label: 'NexSmart',
  },
]
const columns = [
  {
    title: '产品小类名称',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
  },
  {
    title: '产品大类名称',
    dataIndex: 'productClassName',
    key: 'productClassName',
    align: 'center',
  },
  {
    title: '产品目录名称',
    dataIndex: 'productCategoryName',
    key: 'productCategoryName',
    align: 'center',
  },
  {
    title: '产品小类类别',
    dataIndex: 'kind',
    scopedSlots: { customRender: 'kind' },
    key: 'kind',
    align: 'center',
  },
  {
    title: '产品小类类型',
    dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
    align: 'center',
  },
  {
    title: '应用标识',
    dataIndex: 'appTags',
    scopedSlots: { customRender: 'appTags' },
    key: 'appTags',
    align: 'center',
  },
  {
    title: '发布区域',
    dataIndex: 'regionIdentifiers',
    key: 'regionIdentifiers',
    scopedSlots: { customRender: 'regionIdentifiers' },
    align: 'center',
  },
  {
    title: '物模型ID',
    dataIndex: 'productId',
    key: 'productId',
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]

function productSubClassType(type) {
  return PRODUCT_SUB_CLASS_TYPE[type] ?? ''
}

function productSubClassKind(kind) {
  return PRODUCT_SUB_CLASS_KIND[kind] ?? ''
}
function appTagText(appTag) {
  return APP_TAG[appTag] ?? ''
}
function screenResolutionText(screenResolution) {
  return SCREEN_RESOLUTION[screenResolution] ?? ''
}
export default {
  FILTER_OPTION_PRODUCT_SUB_CLASS_SUB_CLASS,
  FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_CATEGORY,
  FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_CLASS,
  FILTER_OPTION_PRODUCT_SUB_CLASS_PRODUCT_PRODUCT_ID,
  FILTER_OPTION_RELATED_INTERNAL_MODEL,
  FILTER_OPTION_RELATED_IMAGE_TYPE_IDS,
  FILTER_OPTION_APP_TAG,
  FILTER_OPTIONS,
  columns,
  PRODUCT_SUB_CLASS_TYPE,
  PRODUCT_SUB_CLASS_KIND,
  PRODUCT_SUB_CLASS_TYPE_OPTIONS,
  PRODUCT_SUB_CLASS_KIND_OPTIONS,
  APP_TAG,
  APP_TAG_OPTIONS,
  SCREEN_RESOLUTION,
  SCREEN_RESOLUTION_OPTIONS,
  productSubClassType,
  productSubClassKind,
  appTagText,
  screenResolutionText,
}
